import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

import { useTabbar } from '@common/providers/useTabbar';
import { Page } from '@common/ui/Page';

import { Verification } from '@widgets/verification/Verification';

const search = z.object({
  gender: z.enum(['male', 'female']),
  canPass: z.boolean().optional(),
});

export const Route = createFileRoute('/verification')({
  component: RouteComponent,
  validateSearch: search,
});

function RouteComponent() {
  const tabbar = useTabbar();
  const { gender, canPass } = Route.useSearch();

  useEffect(() => {
    tabbar.setShowNavigation(false);
  }, []);

  return (
    <Page hasBackground>
      <Verification gender={gender} canPass={canPass} />
    </Page>
  );
}
